module.exports = __webpack_public_path__ + "img/border_bg.9dae3ca3.jpg";